export default __webpack_public_path__ + "96676f0ce11f8bede93e1288df5fa5c9.png";